// GET /customers is deliberately ownership-filtered (a non-admin only sees
// customers they personally created) — see server.py's list_customers. But
// Sales documents (Customer Sales Orders, Delivery Challans, Tax Invoices)
// are never ownership-filtered themselves: any authenticated user can see
// any of them. Resolving a document's customer_id through the filtered
// /customers list left those documents showing "—" for the customer name
// whenever someone else had created that customer record — even though the
// user could already see the whole document. GET /customers/names-lookup is
// a read-only, unfiltered id→name lookup built for exactly this; merge it
// in as a fallback so every customer_id resolves to at least a name.
export function buildCustomerMap(customers, nameLookup) {
  const map = Object.fromEntries((customers || []).map((c) => [c.id, c]));
  for (const n of nameLookup || []) {
    if (!map[n.id]) map[n.id] = n;
  }
  return map;
}
